var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/dashboard_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H11V13H3V3ZM21.0001 3H13.0001V9H21.0001V3ZM8.99986 11V4.99996H4.99986V11H8.99986ZM19 6.99996V4.99996H15V6.99996H19ZM19 13V19H15V13H19ZM8.99986 19V17H4.99986V19H8.99986ZM21.0001 11H13.0001V21H21.0001V11ZM3 15H11V21H3V15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.962849c05e77140d6e12082582697ed3.svg";
export { ForwardRef as ReactComponent };